// filepath: resources/front/default/js/components/aos.js

import AOS from 'aos';

export const AOSConfig = {
    disable: false,
    easing: 'ease-out-back',
    duration: 1000,
    delay: 0,
    once: true,
    mirror: false,
    offset: 120,
    anchorPlacement: 'top-bottom',
    disableMutationObserver: true,
};

let _initialized = false;

export function initAOS() {
    if (!_initialized) {
        AOS.init(AOSConfig);
        _initialized = true;
        return;
    }
    AOS.refreshHard();
}

export function resetAOSForRestore(root = document) {
    const vh = window.innerHeight;
    root.querySelectorAll('[data-aos]').forEach(el => {
        const r = el.getBoundingClientRect();
        if (!(r.top < vh && r.bottom > 0)) {
            el.classList.remove('aos-animate');
        }
    });
    AOS.refreshHard();
}